import React from 'react';
import { AlertTriangle, XCircle, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-[#060919] relative border-t border-white/5" data-id="element-296">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-297">
        <div className="text-center mb-16" data-id="element-298">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-299">
            Vivir bajo ataque energético es como intentar correr un maratón con
            una <span className="text-red-400" data-id="element-300">mochila llena de piedras</span>.
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-301">
            Te agotas el doble, avanzas la mitad y tu brillo personal se apaga.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-302">
          <div className="bg-[#1a1f3a]/50 border border-red-500/20 rounded-2xl p-8 text-center hover:border-red-500/40 transition-colors" data-id="element-303">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-304">
              <BatteryWarning className="w-8 h-8 text-red-400" data-id="element-305" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-306">
              Agotamiento Crónico
            </h3>
            <p className="text-gray-400" data-id="element-307">
              Te despiertas más cansado de lo que te acostaste. Tu energía es
              drenada constantemente por vampiros energéticos o entidades.
            </p>
          </div>

          <div className="bg-[#1a1f3a]/50 border border-red-500/20 rounded-2xl p-8 text-center hover:border-red-500/40 transition-colors" data-id="element-308">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-309">
              <AlertTriangle className="w-8 h-8 text-red-400" data-id="element-310" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-311">
              Bloqueos Inexplicables
            </h3>
            <p className="text-gray-400" data-id="element-312">
              Proyectos que se caen a última hora, dinero que no rinde, y una
              racha de "mala suerte" que desafía toda lógica.
            </p>
          </div>

          <div className="bg-[#1a1f3a]/50 border border-red-500/20 rounded-2xl p-8 text-center hover:border-red-500/40 transition-colors" data-id="element-313">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-314">
              <XCircle className="w-8 h-8 text-red-400" data-id="element-315" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-316">
              Pesadez y Ansiedad
            </h3>
            <p className="text-gray-400" data-id="element-317">
              Esa sensación constante en la nuca, insomnio, pesadillas y un
              ruido mental que no te permite encontrar la paz.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#1a1f3a] to-[#0a0e27] border border-yellow-500/20 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-318">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-white" data-id="element-319">
            ¿Por qué lo que has intentado{' '}
            <span className="text-yellow-400" data-id="element-320">NO funcionó</span>?
          </h3>

          <div className="space-y-6 max-w-3xl mx-auto" data-id="element-321">
            <div className="flex items-start" data-id="element-322">
              <div className="flex-shrink-0 mt-1" data-id="element-323">
                <XCircle className="w-6 h-6 text-yellow-500" data-id="element-324" />
              </div>
              <p className="ml-4 text-lg text-gray-300" data-id="element-325">
                <strong className="text-white" data-id="element-326">
                  Las limpiezas superficiales no bastan.
                </strong>{' '}
                Un incienso o una oración casual es como intentar apagar un
                incendio forestal con un vaso de agua. No cierran los "agujeros"
                por donde la energía se sigue fugando.
              </p>
            </div>

            <div className="flex items-start" data-id="element-327">
              <div className="flex-shrink-0 mt-1" data-id="element-328">
                <XCircle className="w-6 h-6 text-yellow-500" data-id="element-329" />
              </div>
              <p className="ml-4 text-lg text-gray-300" data-id="element-330">
                <strong className="text-white" data-id="element-331">El miedo te debilita.</strong> La
                paranoia y el temor constante solo debilitan más tu escudo
                natural (tu aura), haciéndote más susceptible a nuevos ataques.
              </p>
            </div>

            <div className="flex items-start" data-id="element-332">
              <div className="flex-shrink-0 mt-1" data-id="element-333">
                <XCircle className="w-6 h-6 text-yellow-500" data-id="element-334" />
              </div>
              <p className="ml-4 text-lg text-gray-300" data-id="element-335">
                <strong className="text-white" data-id="element-336">Falta de sellado.</strong> No
                basta con "limpiar"; si no sabes programar una protección y
                sellar tu campo, la carga negativa regresa al día siguiente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}